import styled, {css} from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const StyledTable = styled.table` 
    background-color: transparent;
    margin: 30px;
    border-collapse: collapse;
    font-family: Roboto Condensed, serif;   
    font-weight: 300;
    font-size: 15px;
    
    @media (max-width: 768px) {
        transform: scale(0.8);
    }
    
    @media (max-width: 576px) {
        transform: scale(1);
        display: block;
    }
`;

export const TableBody = styled.tbody`
    @media (max-width: 576px) {
        display: block;
    }
`;

export const TableFooter = styled.tfoot`
    @media (max-width: 576px) {
        display: block;
    }
`;

export const StyledTr = styled.tr`   
    &:nth-child(even) {
        background-color: #dddddd90;
    }
    
    @media (max-width: 576px) {
        display: block;
    }
`;

export const TableHead = styled.thead`
    background: linear-gradient(to right, #8aab00, ${MAIN_COLOR});
    
    @media (max-width: 576px) {
        display: block;
        
        & ${StyledTr} {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }
    }
`;

export const StyledTh = styled.th`
    font-family: BlenderProBold, serif;
    color: black;
    height: 40px;
    font-size: 15px;
    text-align: centenr;
    padding-left: 30px;
    padding-right: 30px;
    
    @media (max-width: 576px) {
        display: block;
    }
`;

export const StyledTd = styled.td`
    text-align: center;
    font-size: 14px;
    padding: 10px;
    
    @media (max-width: 576px) {
        user-select: none;
        width: 500px;
        display: block;
        border: none;
        border-bottom: 1px solid white; 
        position: relative;
        text-align: right;
        font-size: 13px;
        
        &:before {
            position: absolute;
            left: 15px;
            white-space: nowrap;
        }
        
        &:nth-child(1) {
            background: linear-gradient(to right, #8aab00, ${MAIN_COLOR});
        }
        
        ${({adminTable}) => adminTable === false && css`
            &:nth-child(2):before { content: "Zajęta pozycja"; color: grey; }
            &:nth-child(3):before { content: ""; color: grey; }
            &:nth-child(4):before { content: "Lokalizacja"; color: grey; }
            &:nth-child(5):before { content: "Data rozpoczęcia"; color: grey; }
            &:nth-child(6):before { content: "Data zakończenia"; color: grey; }
        `}
    }
    
    @media (max-width: 520px) {
        width: 400px;
    }   
    
    @media (max-width: 420px) {
        width: 300px;
    }   
   
    @media (max-width: 320px) {
        width: 200px;
    }   
`;

export const StyledFooterDiv = styled.div`   
    font-family: Roboto Condensed, serif;
`;

export const StyledFooterText = styled.span`
    font-weight: bold;    
`;

export const SearchBar = styled.input`
    margin-top: 20px;
    font-family: Roboto Condensed, serif;
    width: 80%;
    max-width: 400px;
    padding: 5px;
    border: 1px solid black;
    border-radius: 10px;
    margin-bottom: 30px;
    
    &:focus {
        outline: ${MAIN_COLOR} solid 2px;
    }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
    cursor: pointer;
    transition: 2s all ease-in-out;
    
    &:hover {
        color: red;
    }
`;
